import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

/**
 * Hook to check if badge verification clock-in feature is enabled.
 *
 * @returns Whether badge verification clock-in feature is enabled
 */
export function useIsBadgeVerificationClockInEnabled(): boolean {
  return useCbhFlag(CbhFeatureFlag.ENABLE_BADGE_VERIFICATION_CLOCK_IN, {
    defaultValue: false,
  });
}
